import { render, staticRenderFns } from "./StudentsByRegistrationDate.vue?vue&type=template&id=59f23cf3&scoped=true&"
import script from "./StudentsByRegistrationDate.vue?vue&type=script&lang=js&"
export * from "./StudentsByRegistrationDate.vue?vue&type=script&lang=js&"
import style0 from "./StudentsByRegistrationDate.vue?vue&type=style&index=0&id=59f23cf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f23cf3",
  null
  
)

export default component.exports